import React, { Component } from 'react';
import banner from '../../../assets/images/ban-image.png';
import {Link} from 'react-router-dom';

class Landing extends Component {
    render() {
        return (
            <div>
                <section className="get-started-section">
                    <div className="row pd-ban mar-mob">
                        <div className="col-lg-7 col-sm-12 col-md-12">
                            <h1 className="text-header-title"> Take Your Career To <br />New Heights </h1>
                            <Link  className="btn btn-getstarted rounded"> Get Started </Link>
                            <br />
                            <br />
                            <br />
                            <div className="row">
                                <div className="col-lg-6 col-xl-4 mb-3 mb-lg-0 text-center">
                                    <div className="card card-style10">
                                        <div className="flag">
                                            <p className="flag__text"> <span>Upto </span><span className="nowrap off-per">50% off</span></p>
                                        </div>
                                        <div className="card-body text-left">
                                            <Link  to="/course/post-graduate-program-in-data-science" class="bgs">
                                                <h2 className="font-green-strip font-courses-ban">Post Graduate Program in Data Science</h2>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-4 mb-3 mb-lg-0 text-center">
                                    <div className="card card-style11">
                                        <div className="flag">
                                            <p className="flag__text"> <span>Upto </span><span className="nowrap off-per">34% off</span></p>
                                        </div>
                                        <div className="card-body text-left">
                                            <Link to="/course/post-graduate-program-in-data-engineering" class="bgs">
                                                <h2 className="font-courses-ban font-blue-strip">Post Graduate Program in Data Engineering</h2>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-4 mb-3 mb-lg-0 text-center">
                                    <div className="card card-style12 ">
                                        <div className="flag">
                                            <p className="flag__text"> <span>Upto </span><span className="nowrap off-per">32% off</span></p>
                                        </div>
                                        <div className="card-body text-left">
                                            <Link to="/course/post-graduate-program-in-data-analytics"  class="bgs">
                                                <h2 className="font-pink-strip font-courses-ban">Post Graduate Program in Data Analytics</h2>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-5 col-sm-12 col-md-12">
                            <div className="banner-img" >
                                <img src={banner} alt="epn logo" className="imag-ban" />
                            </div>
                        </div>
                    </div>
                  <p class="morque-title">
                        {// eslint-disable-next-line
}<marquee   onmouseover="this.stop();" onmouseout="this.start(); "> edu plus now in association with the Indian Statistical Institute, Pune has launched weekend
                  and weekday classroom and online Post Graduate Program in Data Science. <Link 
                     class="marquee-enroll-now" href="course/post-graduate-program-in-data-science">Enroll Now </Link> 
               </marquee>
            </p>
                </section>
            </div>
        );
    }
}

export default Landing;